import request from '@/axios'
import { GeneralSelectorDto } from './types'


/**
 * 超级管理员：单位信息列表
 */
export const unitInfoList = (
    loader?: RequestLoader
): Promise<IResponse<GeneralSelectorDto[]>> => {
    return request.get({ url: '/Selector/UnitInfoList', loader })
}

/**
 * 超级管理：获取插件版本列表
 */
export const pluginVersionInfoList = (
    loader?: RequestLoader
): Promise<IResponse<GeneralSelectorDto[]>> => {
    return request.get({ url: '/Selector/PluginVersionInfoList', loader })
}

/**
 * 超级管理：远程搜索账号信息
 * @param keyword 关键词
 */
export const searchAccountInfoList = (
    keyword: string,
    loader?: RequestLoader
): Promise<IResponse> => {
    return request.get({ url: '/Selector/SearchAccountInfoList', params: { keyword }, loader })
}

/**
 * 超级管理：账号一般角色列表
 */
export const generalAccountRoleList = (
    loader?: RequestLoader
): Promise<IResponse<GeneralSelectorDto[]>> => {
    return request.get({ url: '/Selector/GeneralAccountRoleList', loader })
}

/**
 * 普通管理员：获取账号信息列表
 */
export const myUserList = (
    loader?: RequestLoader
): Promise<IResponse<GeneralSelectorDto[]>> => {
    return request.get({ url: '/Selector/MyUserList', loader })
}

/**
 * 所有人：Temu站点信息列表
 */
export const temuSiteInfoList = (
    loader?: RequestLoader
): Promise<IResponse<GeneralSelectorDto[]>> => {
    return request.get({ url: '/Selector/TemuSiteInfoList', loader })
}

/**
 * 所有人：Temu全托管仓库信息列表
 */
export const temuFullyWarehouseInfoList = (
    loader?: RequestLoader
): Promise<IResponse<GeneralSelectorDto[]>> => {
    return request.get({ url: '/Selector/TemuFullyWarehouseInfoList', loader })
}

/**
 * 所有人：Temu单位店铺列表
 */
export const temuShopInfoList = (
    loader?: RequestLoader
): Promise<IResponse<GeneralSelectorDto[]>> => {
    return request.get({ url: '/Selector/TemuShopInfoList', loader })
}

/**
 * 所有人：Temu单位全托管店铺列表
 */
export const temuFullyShopInfoList = (
    loader?: RequestLoader
): Promise<IResponse<GeneralSelectorDto[]>> => {
    return request.get({ url: '/Selector/TemuFullyShopInfoList', loader })
}

/**
 * 所有人：Temu单位半托管店铺列表
 */
export const temuSemiShopInfoList = (
    loader?: RequestLoader
): Promise<IResponse<GeneralSelectorDto[]>> => {
    return request.get({ url: '/Selector/TemuSemiShopInfoList', loader })
}

/**
 * 所有人：Temu商品分类列表
 */
export const temuProductCategoryList = (
    loader?: RequestLoader
): Promise<IResponse<GeneralSelectorDto[]>> => {
    return request.get({ url: '/Selector/TemuProductCategoryList', loader })
}

/**
 * 超级管理员：远程搜索Temu店铺信息
 * @param keyword 关键词
 */
export const searchTShopInfoList = (
    keyword: string,
    loader?: RequestLoader
): Promise<IResponse> => {
    return request.get({ url: '/Selector/SearchTShopInfoList', params: { keyword }, loader })
}

/**
 * 超级管理员：远程搜索Temu全托管店铺信息
 * @param keyword 关键词
 */
export const searchFullyTShopInfoList = (
    keyword: string,
    loader?: RequestLoader
): Promise<IResponse> => {
    return request.get({ url: '/Selector/SearchFullyTShopInfoList', params: { keyword }, loader })
}

/**
 * 超级管理员：远程搜索Temu半托管店铺信息
 * @param keyword 关键词
 */
export const searchSemiTShopInfoList = (
    keyword: string,
    loader?: RequestLoader
): Promise<IResponse> => {
    return request.get({ url: '/Selector/SearchSemiTShopInfoList', params: { keyword }, loader })
}

/**
 * 所有人：仓库信息列表
 */
export const warehouseInfoList = (
    loader?: RequestLoader
): Promise<IResponse<GeneralSelectorDto[]>> => {
    return request.get({ url: '/Selector/WarehouseInfoList', loader })
}

/**
 * 所有人：产品信息列表
 */
export const productInfoList = (
    loader?: RequestLoader
): Promise<IResponse<GeneralSelectorDto[]>> => {
    return request.get({ url: '/Selector/ProductInfoList', loader })
}